import React from "react";

export function NotFound(): JSX.Element {
    return (
        <h1 className="text-2xl text-red">404 Not Found</h1>
    );
}

export default NotFound;
